import React, { useEffect, useState } from "react";
import Hero from "./Hero";
import FeaturedTournament from "./FeaturedTournament";
import AllGames from "./AllGames";

import { func, func1 } from "../../Utilities/logFunc";
import { getAccountDailyReward, getAccountProfile, getDailyReward, isUserPremium } from "../../Utilities/controller";
import DailyLoginModal from "../Profile/DailyLoginModal";
import DailyLoginRewardModal from "./DailyLoginReward/DailyLoginRewardModal";
import JoinViaInviteCodeModal from "./JoinViaCode/JoinViaInviteCodeModal";
import TangerinePaymentStatus from "../Subscription/TangerinePaymentStatus";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useProfileDataContext } from "./ProfileContext";

const Main = ({ handleClickGame }) => {
  const [accountDailyReward, setAccountDailyReward] = useState(null);
  const [showDLR, setShowDLR] = useState(false);
const [dailyRewardList, setDailyRewardList] = useState([]);
const [showJVC, setShowJVC] = useState(false)
  const [searchParams] = useSearchParams()
  const { profileData, updateProfileData } = useProfileDataContext()
  const [isTangerineSubscription, setIsTangerineSubscription ] = useState(false)
  const [tangerineParams, setTangerineParams ] = useState({})

    // console.log(code.get('code'), "***********")
  useEffect(() => {
    if(!showJVC && searchParams.get('code')) {
      setShowJVC(true);
    }
  }, [])
  const fetchDailyRewardList = async (pageNo) => {
    try {
      //   console.log("user_data", user_data);

      let data = {
        skip: 0,
        limit: 100,
        day: accountDailyReward?.currentDay,
        sortBy: "day",
        sort: "asc",
      };

      const res = await getDailyReward(data);

      if (res?.data?.list) {
        setDailyRewardList(res?.data?.list);
      }
      func(res);
    } catch (error) {
      func("avatar 13", error?.response?.data?.errors?.[0]?.msg);
    }
  };
 
  
  const fetchAccountDailyRewardList = async () => {
    try {
      const res = await getAccountDailyReward();

      if (res?.data?.success) {
        setAccountDailyReward(res?.data?.item);
      }
      func(res);
    } catch (error) {
      func("avatar 13", error?.response?.data?.errors?.[0]?.msg);
    }
  };
  // const fetchGetSettings = ()=>{
  //   try{
  //     const res = await getSettingsList()
  //   }
  // }
  useEffect(() => {
    // console.log("Main Page")
    fetchAccountDailyRewardList()
    fetchDailyRewardList()

    if(searchParams.get("correlatorId")) {
      const params = {};

      for (let entry of searchParams.entries()) {
        // console.log(entry[1])
        params[entry[0]] = entry[1]
        // params.push(entry);
    }
      setTangerineParams(params)
      setIsTangerineSubscription(true);
    }
    // fetch()
  }, []);
  return (
    <div class="content">
      <div className="content-inner">
      <div class="row gy-4">
        {isTangerineSubscription && <TangerinePaymentStatus show={isTangerineSubscription} tangerineParams={tangerineParams} closePaymentPopUp={() => setIsTangerineSubscription(false)}/> }
        <Hero />
        <FeaturedTournament />
        <AllGames handleClickGame={handleClickGame} />
        {
          dailyRewardList.length >= accountDailyReward?.currentDay && accountDailyReward?.isDailyRewardPopup  ? <DailyLoginRewardModal showDLR={true} setShowDLR={setShowDLR} />:""
        }
        {
          showJVC && 
          <JoinViaInviteCodeModal showJVC={showJVC} setShowJVC={setShowJVC} code ={searchParams.get('code')} />
        }
        
        </div>
      </div>
    </div>
  );
};

export default Main;
